// Price of a race class as shown in the public "Løpsklasser" list.
//
// raceClass.signuppayment is the entry fee (startkontingent) and
// raceClass.signupfee an optional fee charged at signup (påmeldingsavgift);
// the participant pays both, so the row shows the total. The signup flow
// itself still presents the two amounts separately.

function positiveNumber(value) {
    const number = Number(value);
    return Number.isFinite(number) && number > 0 ? number : 0;
}

export function raceClassFeeTotal(raceClass) {
    if (!raceClass || typeof raceClass !== 'object') {
        return 0;
    }
    return positiveNumber(raceClass.signuppayment) + positiveNumber(raceClass.signupfee);
}

export function raceClassFeeText(raceClass) {
    const total = raceClassFeeTotal(raceClass);
    if (total <= 0) {
        return '';
    }
    const grouped = `${Math.round(total)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return `kr ${grouped}`;
}
